import { usePsfPromoteOrSharePageData } from '#src/app/pages/psf/promoteOrShare/pageContext';

export function useContributionCount() {
	const {
		data: {
			petition: {
				promotionStats: { promoterCount, promoterCountLocalized },
			},
			promotionGoal,
			promotionGoalLocalized,
		},
	} = usePsfPromoteOrSharePageData();

	return {
		count: promoterCount,
		localizedCount: promoterCountLocalized,
		completionPercentage: Math.round((promoterCount / promotionGoal) * 100),
		localizedGoal: promotionGoalLocalized,
	};
}
